<div class="crmnp" *ngIf="target">
	<header class="crmnp-head">
		<div class="crmnp-title">
			<strong>{{ target.name }}</strong>
			<span class="crmnp-sub" *ngIf="target.prospect_key">Prospect</span>
			<span class="crmnp-sub" *ngIf="!target.prospect_key">{{ target.debtorno }}<ng-container *ngIf="target.branchcode && target.branchcode !== target.debtorno">·{{ target.branchcode }}</ng-container></span>
			<span class="crmnp-flag" *ngIf="openFollowups">{{ openFollowups }} open follow-up{{ openFollowups > 1 ? 's' : '' }}</span>
		</div>
		<button mat-icon-button type="button" (click)="close()" aria-label="Close notes"><i class="material-icons">close</i></button>
	</header>

	<div class="crmnp-add">
		<div class="crmnp-add-row">
			<select [(ngModel)]="newType" class="crmnp-sel" aria-label="Note type">
				<option value="general">Note</option>
				<option value="call">Call</option>
				<option value="follow_up">Follow-up</option>
			</select>
			<input *ngIf="newType === 'follow_up'" type="date" class="crmnp-sel" [(ngModel)]="newDue" aria-label="Due date">
		</div>
		<textarea [(ngModel)]="newBody" rows="2" class="crmnp-textarea"
			[placeholder]="newType === 'follow_up' ? 'What needs to happen next…' : 'Add a note…'"></textarea>
		<div class="crmnp-add-actions">
			<button mat-raised-button color="primary" type="button" (click)="addNote()" [disabled]="saving || !newBody.trim()">
				{{ saving ? 'Saving…' : 'Add' }}
			</button>
		</div>
	</div>

	<p class="crmnp-status" *ngIf="status">{{ status }}</p>
	<p class="crmnp-empty" *ngIf="loading">Loading history…</p>
	<p class="crmnp-empty" *ngIf="!loading && !notes.length">No CRM history yet.</p>

	<div class="crmnp-list">
		<div class="crmnp-note" *ngFor="let n of notes"
			[class.is-followup]="isOpenFollowup(n)" [class.is-overdue]="isOverdue(n)">
			<i class="material-icons crmnp-icon">{{ typeIcons[n.note_type] || 'sticky_note_2' }}</i>
			<div class="crmnp-note-main">
				<div class="crmnp-note-meta">
					<span class="crmnp-type">{{ typeLabels[n.note_type] || n.note_type }}</span>
					<span>{{ n.note_date }}</span>
					<span *ngIf="n.salesmanname || n.salesperson">· {{ n.salesmanname || n.salesperson }}</span>
					<span class="crmnp-geo" *ngIf="n.has_geo" title="GPS-stamped visit"><i class="material-icons">place</i></span>
				</div>
				<div class="crmnp-body">{{ n.body }}</div>
				<div class="crmnp-due" *ngIf="n.note_type === 'follow_up'">
					<ng-container *ngIf="!n.completed_at">Due {{ n.due_date || '—' }}<span *ngIf="isOverdue(n)"> · overdue</span></ng-container>
					<ng-container *ngIf="n.completed_at">Completed {{ n.completed_at | slice:0:10 }}</ng-container>
				</div>
			</div>
			<button *ngIf="isOpenFollowup(n)" mat-stroked-button color="primary" type="button" class="crmnp-done" (click)="completeFollowup(n)">Done</button>
		</div>
	</div>
</div>
